/*******************************
 *  CART QTY UPDATE – FINAL FIX
 *******************************/

window.moneyFormat = window.moneyFormat || "{{ shop.money_format }}";

/* Format money safely */
function formatMoney(amount) {
  try {
    return Shopify.formatMoney(amount, window.moneyFormat);
  } catch (e) {
    return "Rs. " + (amount / 100).toFixed(2);
  }
}

/* Update subtotal from custom totals */
function updateCustomSubtotal() {
  let subtotal = 0;

  document.querySelectorAll(".my-line-total").forEach(span => {
    const raw = span.innerHTML.replace(/[^0-9]/g, "");
    if (raw) subtotal += parseInt(raw, 10);
  });

  const subEl = document.querySelector(".my-cart-subtotal");
  if (subEl) {
    subEl.innerHTML = formatMoney(subtotal);
  }
}

/* Sync quantity to Shopify server (IMPORTANT) */
function syncWithShopify(line, qty) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      line: parseInt(line, 10),
      quantity: qty
    })
  })
    .then(res => res.json())
    .then(cart => {
      updateCustomSubtotal(); // refresh subtotal again
    })
    .catch(err => console.error("Cart sync error:", err));
}

/* Main quantity handler */
document.addEventListener("input", function (e) {
  if (!e.target.matches("input[data-ajax-qty]")) return;

  const qtyInput = e.target;

  const key = qtyInput.dataset.id;
  const line = qtyInput.dataset.line;
  const qty = parseInt(qtyInput.value, 10);

  if (isNaN(qty) || qty < 0) return;

  /* Update custom line total instantly */
  const lineSpan = document.querySelector(`span.my-line-total[data-key="${key}"]`);

  if (lineSpan) {
    const unitPrice = parseInt(lineSpan.dataset.price, 10);
    const newTotal = unitPrice * qty;
    lineSpan.innerHTML = formatMoney(newTotal);
  }

  /* Update subtotal instantly */
  updateCustomSubtotal();

  /* Prevent multiple rapid calls */
  clearTimeout(window.cartUpdateTimer);

  window.cartUpdateTimer = setTimeout(() => {
    syncWithShopify(line, qty); // update Shopify server
  }, 300);
});

/* When AJAX cart redraws DOM */
document.addEventListener("ajaxCart.afterCartLoad", function () {
  setTimeout(updateCustomSubtotal, 150);
});
